import {Dimensions, Point, Rectangle} from "./geometry";

export function scrollPosition(node: Element): Point {
  return {
    x: node.scrollLeft,
    y: node.scrollTop
  };
}

export function appDimensions(): {canvasBounds: Rectangle, letterSize: Dimensions} {
  return {
    canvasBounds: projectSize(),
    letterSize: letterSize()
  };
}

function projectSize(): Rectangle {
  const project = document.querySelector(".project");
  if (project == null) {
    throw "There's no .project HTML element yet";
  } else {
    const projectRect = project.getBoundingClientRect();
    return {
      start: {x: Math.round(projectRect.left), y: Math.round(projectRect.top)},
      end: {x: Math.round(projectRect.left + projectRect.width), y: Math.round(projectRect.top + projectRect.height)}
    };
  }
}

function letterSize(): Dimensions {
  const numberOfX = 100;
  let calculator = document.querySelector(".calculate-letter-size") as HTMLElement;
  if (calculator == null) {
    calculator = document.createElement("div");
    calculator.setAttribute("class", "calculate-letter-size");
    calculator.innerHTML = Array(numberOfX).join("X") + Array(numberOfX - 1).join("<br />X");
    document.body.appendChild(calculator);
  }
  const width = calculator.offsetWidth / (numberOfX - 1);
  const height = calculator.offsetHeight / (numberOfX - 1);
  document.body.removeChild(calculator);

  return {width: width, height: height};
}



// WEBPACK FOOTER //
// ./assets/js/dimensions.ts


// WEBPACK FOOTER //
// ./assets/js/dimensions.ts